<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("Screen Aggregator Report") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="distData.length > 0 ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("Distributor") }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="distData"
                v-model="fetchReportsDetail.distributorData"
                :searchable="true"
                label="d_company_name"
                track-by="d_id"
                placeholder="Select Distributor"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <!-- Date From-->
          <div class="col-lg-6 col-xl-4 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  v-if="fetchReportsDetail.from_date"
                  v-on:click="clearDate(2)"
                  class="btn-clearDate"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="fetchReportsDetail.from_date"
                  name="selectenddate_1"
                  id="selectenddate_1"
                  v-validate="'required'"
                  :typeable="true"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fetchReportsDetail.from_date ? 'active' : ''">{{
                  $t("From Show Date")
                }}</label>
              </div>
            </div>
          </div>

          <!-- Date To -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  v-if="fetchReportsDetail.to_date"
                  v-on:click="clearDate('to_date')"
                  class="btn-clearDate"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="fetchReportsDetail.to_date"
                  name="selectenddate_3"
                  id="selectenddate_3"
                  v-validate="'required'"
                  :typeable="true"
                ></Datepicker>
                <label :class="fetchReportsDetail.to_date ? 'active' : ''">{{
                  $t("To Show Date")
                }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="distData.length > 0 ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("Cinema") }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="Cinemas"
                v-model="fetchReportsDetail.cinema_id"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="Screens.length > 0 ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("Screen") }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="Screens"
                v-model="fetchReportsDetail.screenData"
                :searchable="true"
                label="screen_name"
                track-by="screen_id"
                placeholder="Select Screen"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <!--<div style="width: 100%"></div>-->

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button
              @click.prevent.stop="getAggregatorSalesData"
              class="btn-blue-lg w-100"
            >
              {{ $tc("fetch") }} {{ $tc("report") }}
            </button>
          </div>
          <div
            class="col-xl-12 d-flex align-self-right justify-content-end"
            style="float:right"
            v-if="aggregatorSalesRecords.length > 0"
          >
            Download as:
            <a
              target="_blank"
              @click="ExportExcel()"
              title="Download as Excel"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
            <a
              target="_blank"
              @click="ExportPdf()"
              title="Download as PDF"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/pdf-icon.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>
      <div
        style="overflow-x:scroll;width: auto !important"
        v-if="aggregatorSalesRecords.length > 0"
        ref="exportable_table"
      >
        <table class="swc-report-table" border="1">
          <thead class="bg-lightgrey font-weight-bold">
            <th>Screen Name</th>
            <th>Distributor Name</th>
            <th>Movie</th>
            <th>Show Date</th>
            <th>Show Time</th>
            <th>Class</th>
            <th>Price/Tkt</th>
            <th>Complimentary Tkts</th>
            <th>Admits(without compl.)</th>
            <th>Total Admits</th>
            <th>Gross</th>
            <th>Tax</th>
            <th>Net</th>
          </thead>
          <tbody>
            <template v-for="(aggRecords, aggIndex) in aggregatorSalesRecords">
              <tr
                v-for="(aggScreenData,
                aggScreenIndex) in aggRecords.screen_array"
                :key="aggScreenIndex + 'aggIndex' + aggIndex"
              >
                <td class="text-left">{{ aggScreenData.screen_name }}</td>
                <td class="text-left">{{
                  aggScreenData.og_d_name || aggScreenData.md_dname
                }}</td>
                <td class="text-left">{{ aggScreenData.movie_title }}</td>
                <td class="text-left">{{ aggScreenData.t_show_date }}</td>
                <td class="text-left">{{ aggScreenData.t_show_time }}</td>
                <td class="text-left">{{ aggScreenData.seat_type_name }}</td>
                <td class="text-right">{{
                  currFormat(aggScreenData.t_gross_amount)
                }}</td>
                <td class="text-right">{{
                  aggScreenData.complimentary_tickets
                }}</td>
                <td class="text-right">{{
                  aggScreenData.noncomplimentary_tickets
                }}</td>
                <td class="text-right">{{ aggScreenData.no_of_tickets }}</td>
                <td class="text-right">{{
                  currFormat(aggScreenData.t_gross_amount_before_offer)
                }}</td>
                <td class="text-right">{{
                  currFormat(aggScreenData.totalTax)
                }}</td>
                <td class="text-right">{{
                  currFormat(aggScreenData.t_net_amount_before_offer)
                }}</td>
              </tr>
            </template>
            <tr class="bg-lightgrey font-weight-bold">
              <td class="text-left" colspan="7">Grand Total</td>
              <td class="text-right">{{
                grandTotal.complimentary_tickets_total
              }}</td>
              <td class="text-right">{{
                grandTotal.noncomplimentary_tickets_total
              }}</td>
              <td class="text-right">{{ grandTotal.admits_total }}</td>
              <td class="text-right">{{
                currFormat(grandTotal.gross_total)
              }}</td>
              <td class="text-right">{{ currFormat(grandTotal.tax_total) }}</td>
              <td class="text-right">{{ currFormat(grandTotal.net_total) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="swc-report" v-if="aggregatorSalesRecords.length == 0">
        <table class="swc-report-table">
          <thead class="bg-lightgrey font-weight-bold">
            <th>Screen Name</th>
            <th>Distributor Name</th>
            <th>Movie</th>
            <th>Show Date</th>
            <th>Show Time</th>
            <th>Class</th>
            <th>Price/Tkt</th>
            <th>Admits</th>
            <th>Gross</th>
            <th>Tax</th>
            <th>Net</th>
          </thead>
          <tbody>
            <tr>
              <td colspan="11">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      aggregatorSalesRecords: [],
      excelFilePath: "",
      distData: [],
      Screens: [],
      Cinemas: [],
      fetchReportsDetail: {
        cinema_id: null,
        distributorData: {},
        screenData: {},
        from_date: moment()
          .subtract("weeks", 1)
          .toDate(),
        to_date: new Date(),
        d_id: null,
        screen_id: null,
      },
      aggregatorSalesRecordsExcel: [],
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    const { cinema_id } = this.secureStore.get("USINFO");
    this.getCinemaList(cinema_id);
    this.getDistributor();

    // if (CinemaObj) {
    //   this.onSelectCinema(CinemaObj);
    // }
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onSelectCinema(CinemaObj);
    //   }
    // },
    excelFilePath(value) {
      this.excelFilePath = value;
    },
    "fetchReportsDetail.cinema_id.cine_id"(value) {
      this.getScreenList();
    },
  },
  computed: {
    grandTotal() {
      let obj = {};
      obj[
        "complimentary_tickets_total"
      ] = this.aggregatorSalesRecordsExcel.reduce(
        (acc, { complimentary_tickets }) => {
          return acc + complimentary_tickets;
        },
        0
      );
      obj[
        "noncomplimentary_tickets_total"
      ] = this.aggregatorSalesRecordsExcel.reduce(
        (acc, { noncomplimentary_tickets }) => {
          return acc + noncomplimentary_tickets;
        },
        0
      );
      obj["admits_total"] = this.aggregatorSalesRecordsExcel.reduce(
        (acc, { no_of_tickets }) => {
          return acc + no_of_tickets;
        },
        0
      );
      obj["gross_total"] = this.aggregatorSalesRecordsExcel.reduce(
        (acc, { t_gross_amount_before_offer }) => {
          return acc + t_gross_amount_before_offer;
        },
        0
      );
      obj["tax_total"] = this.aggregatorSalesRecordsExcel.reduce(
        (acc, { totalTax }) => {
          return acc + totalTax;
        },
        0
      );
      obj["net_total"] = this.aggregatorSalesRecordsExcel.reduce(
        (acc, { t_net_amount_before_offer }) => {
          return acc + t_net_amount_before_offer;
        },
        0
      );
      return obj;
    },
  },
  mounted() {},
  methods: {
    onChangeDate: function(e, type){
      if(type == 'from'){
        this.fetchReportsDetail.to_date = new Date(e);
        this.$forceUpdate();
      }
    },
    moment,
    getScreenList: function() {
      this.Screens = [];
      let payload = {
        tableName: "screens",
        screen_is_active: "Y",
        cinema_id: this.fetchReportsDetail.cinema_id.cine_id,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Screens = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getDistributor() {
      let payload = {};
      MasterService.GetDistributors().then((response) => {
        const { data } = response;
        if (data.data.length) {
          this.distData = data.data;
        }
      });
    },
    ExportExcel(type, fn, dl) {
      // var elt = this.$refs.exportable_table;
      // var wb = XLSX.utils.table_to_book(elt, { sheet: "Report Builder FnB" });
      // return dl
      //   ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
      //   : XLSX.writeFile(wb, fn || "ReportBuilderFnB." + (type || "xlsx"));let payload = {
      let payload = {
        cinema_name: this.fetchReportsDetail.cinema_id.cine_name || "",
        cinema_address: this.fetchReportsDetail.cinema_id.cine_address || "",
        d_name: this.fetchReportsDetail.distributorData.d_company_name || "",
        fromDate: this.fetchReportsDetail.from_date
          ? moment(this.fetchReportsDetail.from_date).format("YYYY-MM-DD")
          : null,
        toDate: this.fetchReportsDetail.to_date
          ? moment(this.fetchReportsDetail.to_date).format("YYYY-MM-DD")
          : null,
        screen_name: this.fetchReportsDetail.screenData.screen_name || "-",
        // cinema_name: this.fetchReportsDetail.cinema_id.cine_name || "",
        finalArr: this.aggregatorSalesRecordsExcel,
        screen_id: this.fetchReportsDetail.screenData.screen_id || "-",
        cinema_id: this.fetchReportsDetail.cinema_id.cine_id,
        distributor_id: this.fetchReportsDetail.distributorData.d_id,
      };

      MasterService.getAggregatorReportExcelWithComplimentary(payload).then(
        (response) => {
          const { data } = response;
          if (data.status && data.excelPath != "") {
            window.open(data.excelPath, "_blank");
          } else {
            this.$toasted.show(data.message);
          }
        }
      );
    },
    ExportPdf(type, fn, dl) {
      // var elt = this.$refs.exportable_table;
      // var wb = XLSX.utils.table_to_book(elt, { sheet: "Report Builder FnB" });
      // return dl
      //   ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
      //   : XLSX.writeFile(wb, fn || "ReportBuilderFnB." + (type || "xlsx"));let payload = {
      let payload = {
        cinema_name: this.fetchReportsDetail.cinema_id.cine_name || "",
        cinema_address: this.fetchReportsDetail.cinema_id.cine_address || "",
        d_name: this.fetchReportsDetail.distributorData.d_company_name || "",
        fromDate: this.fetchReportsDetail.from_date
          ? moment(this.fetchReportsDetail.from_date).format("YYYY-MM-DD")
          : null,
        toDate: this.fetchReportsDetail.to_date
          ? moment(this.fetchReportsDetail.to_date).format("YYYY-MM-DD")
          : null,
        screen_name: this.fetchReportsDetail.screenData.screen_name || "-",
        // cinema_name: this.fetchReportsDetail.cinema_id.cine_name || "",
        finalArr: this.aggregatorSalesRecordsExcel,
        screen_id: this.fetchReportsDetail.screenData.screen_id || "-",
        cinema_id: this.fetchReportsDetail.cinema_id.cine_id,
        distributor_id: this.fetchReportsDetail.distributorData.d_id,
      };

      MasterService.getAggregatorReportPdfWithComplimentary(payload).then(
        (response) => {
          const { data } = response;
          if (data.status && data.pdfPath != "") {
            window.open(data.pdfPath, "_blank");
          } else {
            this.$toasted.show(data.message);
          }
        }
      );
    },
    getCinemaList: function(cinema_id) {
      MasterService.GetCinemas({cine_id: cinema_id})
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            // this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function(event) {
      this.getScreenList();
      // this.dropDown.selectedCinema = event;
      // this.dropDown.selectedCinemaName = event.cine_name;
      // this.dropDown.selectedCinemaId = event.cine_id;
      // this.$store.dispatch("selectDropdownCinema", event);
    },
    getAggregatorSalesData(isExcel) {
      this.aggregatorSalesRecords = [];
      this.aggregatorSalesRecordsExcel = [];
      if (!this.fetchReportsDetail.cinema_id) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fetchReportsDetail.from_date) {
        return this.$toasted.show("Select From Date");
      }
      if (!this.fetchReportsDetail.to_date) {
        return this.$toasted.show("Select To Date");
      }
      if (!this.fetchReportsDetail.screenData.hasOwnProperty("screen_id")) {
        return this.$toasted.show("Select screen");
      }
      // if (!this.fetchReportsDetail.distributorData.hasOwnProperty("d_id")) {
      //   return this.$toasted.show("Select Distributor");
      // }
      let loader = this.$loading.show();
      let payload = {
        cinema_name: this.fetchReportsDetail.cinema_id.cine_name || "",
        cinema_address: this.fetchReportsDetail.cinema_id.cine_address || "",
        d_name: this.fetchReportsDetail.distributorData.d_company_name || "",
        distributor_id: this.fetchReportsDetail.distributorData.d_id,
        fromDate: this.fetchReportsDetail.from_date
          ? moment(this.fetchReportsDetail.from_date).format("YYYY-MM-DD")
          : null,
        toDate: this.fetchReportsDetail.to_date
          ? moment(this.fetchReportsDetail.to_date).format("YYYY-MM-DD")
          : null,
        screen_id: this.fetchReportsDetail.screenData.screen_id || "-",
        cinema_id: this.fetchReportsDetail.cinema_id.cine_id,
        // cinema_name: this.fetchReportsDetail.cinema_id.cine_name || "",
        // finalArr: this.finalOutputArray,
      };
      ReportsService.GetAggregatorSalesNewWithComplimentary(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.aggregatorSalesRecords = [...data.Records];
            data.Records.map((x) => {
              this.aggregatorSalesRecordsExcel = [
                ...this.aggregatorSalesRecordsExcel,
                ...x.screen_array,
              ];
            });
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}
.swc-report-table td {
  white-space: nowrap;
}
.swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
.no_border {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/aggregatorSalesNewFormat.vue